// Host del backend v2 (api-v3.levita.mx). Vive aquí, en una hoja sin imports,
// porque lo necesitan tanto utils/axios-request.js como auth/authClient.js y
// axios-request importa authClient: tenerlo en cualquiera de los dos sería un
// ciclo. Ver hosting/.env, bloques #PRODUCTION / #DEVELOP, para cambiarlo sin
// tocar código.
export const LEVITA_URL =
  process.env.REACT_APP_LEVITA_URL || 'https://api-v3.levita.mx';

// Host del backend "mini" (mini.levita.mx). Ver hosting/.env, bloques
// #PRODUCTION / #DEVELOP, para cambiarlo sin tocar código.
export const MINI_LEVITA_URL =
  process.env.REACT_APP_MINI_LEVITA_URL || 'https://mini.levita.mx';

export const API_BASE_URL = `${MINI_LEVITA_URL}/api`;
